
let API_ROUTE_STRING;
let LEGACY_SITE_STRING;
if (window.location.href.includes("localhost")) {
    API_ROUTE_STRING = 'https://localhost:44379/api/';

    LEGACY_SITE_STRING = 'http://localhost:51171/';
} else if (window.location.href.includes("365demo") || window.location.href.includes("365resellerdemo")) {
    API_ROUTE_STRING = 'https://365Api-Lab.virtualdcs.co.uk:443/api/';
    LEGACY_SITE_STRING = '/v4/';
} else if (window.location.href.includes("preview") || window.location.href.includes("cloudcoverservice.com") )  {
    API_ROUTE_STRING = 'https://365Api-preview.virtualdcs.co.uk:443/api/';
    LEGACY_SITE_STRING = '/v4/';
} else {
    API_ROUTE_STRING = 'https://365Api.virtualdcs.co.uk:443/api/';
    LEGACY_SITE_STRING = '/v4/';
}

export const API_ROUTE = API_ROUTE_STRING;
export const LEGACY_SITE = LEGACY_SITE_STRING;
//Routes
export const Routes = {
    // Users
    GET_DATA: 'User/GetData/',

    SYNC_STATE: (orgId) => `User/Organization/${orgId}/SyncState`,
    SYNC_365_DATA: (orgId, type) => `User/Organization/${orgId}/Type/${type}/Sync365Data`,
    JOBS: (orgId) => `User/Organization/${orgId}/Jobs`,
    SELECTED_AND_EXCLUDED: (orgId, jobId, isExcluded) => `User/Job/${jobId}/Organization/${orgId}/isExcluded/${isExcluded}`,

    USER: "User/",
    JOB:"Jobs/",
    EDIT_JOB_DETAIL: (orgId, jobId) =>`User/Organization/${orgId}/Job/${jobId}`,


    //GET_JOB_DATA
    JOB_HISTORY: (jobId,orgId, offset) => `User/Job/${jobId}/Organization/${orgId}/History/Offset/${offset}`,
    JOB_DETAIL: (orgId, jobId) => `User/Organization/${orgId}/Job/${jobId}/Log`,


    ORG_DATA: (orgId, type, startRow) => `User/Organization/${orgId}/Type/${type}/Start/${startRow}/OrgData`,
    COPY_JOBS: (orgId) => `User/Organization/${orgId}/CopyJob`,
    ALL_JOBS_STATUS: 'User/JobsStatus',
    GET_ORG: 'User/Org',
    GET_REPO: 'User/Repository',
    EVENTLOGS: (orgId) => `User/Organization/${orgId}/Eventlogs`,
    GET_IS_ADMIN: 'User/CheckIsAdmin',
    GET_PROGRESS: 'User/GetRegistrationProgress',
    GET_MODERN_PROGRESS: 'User/GetModernRegistrationProgress',
    GET_GROUP: 'User/GetAzureGroup',
    GET_AllAZURE_GROUP: 'User/GetAllAzureGroup',
    CREATE_APPLICATION: 'User/CreateApplication',
    CREATE_APPLICATION_MFA: 'User/CreateApplicationMFA',
    CREATE_GROUP: 'User/AdminGroup/Create',
    ADD_TO_GROUP: 'User/AddUserToAdminGroup',
    CREATE_VBO_USER: 'User/CreateVBOUser',
    CREATE_VBO_USER_MFA: 'User/CreateVBOUserMFA',
    GET_DEVICE_CODE: ( query) =>`User/Query/${query}/DeviceCode`,
    ADD_TO_VEEAM_DEVICE_CODE: 'User/AddToVeeamDeviceCode',
    CREATE_BUCKET: 'User/CreateBucket',
    LOGIN: 'User/Login',
    REG_CHECK: 'User/RegCheck',
    REFRESH_TOKEN: 'User/RefreshToken',
    GET_TEAMSCHAT_ENABLED: 'User/GetTeamsChatEnabled',
    ROLL_BACK: 'User/RollBack',
    GET_LICENSED_USERS: 'User/LicensedUsers',
    GET_PROTECTION_REPORT: 'User/ProtectionReport',
    GET_ORG_USERS: 'User/OrgUsers',
    VALIDATE_TOKEN: 'User/ValidateToken',
    VALIDATE_TOKEN_ADMIN: 'User/ValidateAdmin',
    GET_USER_DETAILS: 'User/GetUserDetails',
    GET_PROCESS_LOGIN: 'User/Login',
    WRITE_LOG: 'User/WriteLog',
    Update_User_Data: 'User/SignupUserInfo',

    //Invoice

    GET_INVOICE_LIST: 'Invoice/InvoiceList',
    GET_INVOICE_LINES: 'Invoice/GetInvoiceLines',
    GET_ADDITION_LINES: 'ConnectWise/GetAdditionsLines',
    GET_COMPANY_AGREEMENT_FOR_ADDITION: 'ConnectWise/GetCompanyAndAgreementForAdditionLines',
    GET_CONNECTWISE_COMPANIES: 'ConnectWise/GetAllCompanies',
    GET_CONNECTWISE_AGREEMENTS: 'ConnectWise/GetAllAgreements',
    GET_CONNECTWISE_CONTACT: 'ConnectWise/CompanyContact',
    GET_CONNECTWISE_ADDITION_FOR_AGREEMENT: 'ConnectWise/GetActiveAdditionsForAgreement',
    GET_ALL_AGREEMENTS: 'ConnectWise/GetAllAgreements',
    CREATE_CONNECTWISE_CONTACT: 'ConnectWise/CompanyContact',
    CREATE_CONNECTWISE_COMPANY: 'ConnectWise/CWCompanies',
    CREATE_CONNECTWISE_AGREEMENT: 'ConnectWise/CreateAgreements',
    PROCESS_CONNECTWISE_ADDITIONLINES: 'ConnectWise/AdditionLines',
    GET_CONNECTWISE_TYPEIDS: 'ConnectWise/CWTypesIds',
    GET_CONNECTWISE_INVOICE: 'ConnectWise/ConnectWiseInvoice',
    CW_PROCESS_INVOICE_PAYMENT: 'ConnectWise/InvoicePayment',
    CW_DELETE_INVOICE_PAYMENT: 'ConnectWise/VoidInvoice',
    CREATE_CONNECTWISE_SUBAGREEMENTS: 'ConnectWise/SubAgreements',
    GET_CONNECTWISE_CLOUDCOVER_CONTACTS: 'ConnectWise/GetCWAndCloudCoverContact',
    GET_CONNECTWISE_INVOICE_PDF: 'ConnectWise/InvoicePDF',
    UPDATE_CONNECTWISE_ADDITION: 'ConnectWise/AdditionStatus',
    
    //Bucket Dashboard

    GET_BUCKETS: 'RemovalProcess/GetBuckets',
    GET_REMOVEDORGLIST: 'RemovalProcess/GetRemovedOrgs',
    DELETE_REMOVED_ORG: (orgId) =>`RemovalProcess/Organization/${orgId}`,

    // Restore
    GET_RESTORE: (orgId) => `Restore/Organization/${orgId}/RestoreSession`,///
    GET_RESTORE_ITEMS: (orgId) => `Restore/Organization/${orgId}/RestoreItems`,///
    GET_RESTORE_FOLDERS: (orgId) => `Restore/Organization/${orgId}/RestoreFolders`,///
    EXPAND_RESTORE_FOLDER: (orgId) => `Restore/Organization/${orgId}/RestoreFolders/Expand`,///
    GET_RESTORE_FOLDER_ITEMS: (orgId) => `Restore/Organization/${orgId}/RestoreFolders/Items`,///
    GET_RESTORE_DEVICE_CODE: (orgId, query) => `Restore/Organization/${orgId}/Query/${query}/DeviceCode`,
    CHECK_DEVICE_CODE: (orgId, code) => `Restore/Organization/${orgId}/DeviceCode/${code}/Check`,
    COMPLETE_RESTORE: 'Restore/Restore',


    RESTORE:"Restore/",
    MAILBOX_DOWNLOAD:'MailBox/Download',
    MAILBOX_ORIGINAL_LOCATION:'MailBox/OriginalLocation',
    MAILBOX_ANOTHER_LOCATION:'MailBox/ToAnotherLocation',
    MAILBOX_MAILTO_OWNER:'MailBox/MailToOwner',
    MAILBOX_MAILTO_SOMEONE:'MailBox/MailToSomeone',

    //OneDrive Restore
    ONEDRIVE_DOWNLOAD: 'OneDrive/Download',
    ONEDRIVE_ORIGINAL_LOCATION: 'OneDrive/OriginalLocation',
    ONEDRIVE_ANOTHER_LOCATION: 'OneDrive/ToAnotherLocation',
    ONEDRIVE_MAILTO_SOMEONE: 'OneDrive/MailToSomeone',

    //Teams Restore
    TEAMS_ORIGINAL_LOCATION: 'Teams/OriginalLocation',
    TEAMS_DOWNLOAD: 'Teams/Download',
    TEAMS_MAILTO_SOMEONE: 'Teams/MailToSomeone',


    //Sharepoint
    SHAREPOINT_DOWNLOAD: 'Sharepoint/Download',
    SHAREPOINT_ORIGINAL_LOCATION: 'Sharepoint/OriginalLocation',
    SHAREPOINT_ANOTHER_LOCATION: 'Sharepoint/ToAnotherLocation',
    SHAREPOINT_MAILTO_SOMEONE: 'Sharepoint/MailToSomeone',



    EXCHANGE_BULK_RESTORE: (restoreSessionsId) => `Restore/RestoreSessions/${restoreSessionsId}/MailBox/BulkRestore`,
    ONEDRIVE_BULK_RESTORE: (restoreSessionsId) => `Restore/RestoreSessions/${restoreSessionsId}/OneDrive/BulkRestore`,
    SEARCH: (orgId) => `Restore/Organization/${orgId}/Search`,
    RESTORE_POINTS: 'Restore/RestorePoints/',
    GET_ACTIVE_SEARCH_LIST: (orgId, userName) =>`Restore/Organization/${orgId}/User/${userName}/ActiveSearch`,
    IS_END_USER: 'Restore/IsEndUser',
    GET_NAVBAR_SETTINGS: 'User/GetNavbarSettings',
    GET_RESTORE_DATES: (orgId, userName) => `Restore/Organization/${orgId}/User/${userName}/RestoreTimes`,
    GET_BANK_ACCOUNT: 'GoCardless/GetBankAccount',
    GET_ORG_STATUS: 'User/OrgStatus',

    ADD_BANK_ACCOUNT: 'GoCardless/CreateBankAccount',
    DELETE_BANK_ACCOUNT: 'GoCardless/DeleteBankAccount',    
    TEST: 'Test/Test',
    GET_RESTORE_DOWNLOADS: (orgId) => `Restore/Organization/${orgId}/Downloads`,
    GET_DOWNLOAD_PRESIGNEDURL: 'Restore/GetDownloadPresignedURL',
    DELETE_S3_OBJECTS: (orgId, key) => `Restore/Organization/${orgId}/Key/${key}`,
    GET_LITIGATION_HOLD: 'Restore/LitigationHold',
    GET_LITIGATION_PRESIGNEDURL: 'Restore/GetLitigationPresignedURL',
    LITIGATION_HOLD: 'Restore/Litigation',
    LITIGATION_DESCRIPTION_EDIT: 'User/Litigation',
    LOG_RESTORESESSION: 'Restore/LogRestoreSession',
    RESTORE_SEND_EMAIL: 'Restore/RestoreSendMail',
    RESTORESESSION_EVENT_LIST: 'Restore/RestoreSessionEvent',

    // Task 14 — PST export progress for one restore session. Polled only while an export is
    // actually running; see pollPstExportStatus in RestoreTree.
    PST_EXPORT_STATUS: (orgId, restoreId) => `Restore/PstExportStatus/${orgId}/${restoreId}`,
    LOG_RESTORESESSION_Comment: 'Restore/RestoreSessionComment',
    GET_RESTORESESSION_REPORT: 'Restore/RestoreSessionAudit',
    GET_FILTERED_RESTORESESSION: 'Restore/GetFilteredRestoreSessions',
    GET_ORG_ALLUSERS: 'Restore/GetOrgAllUsers',
    // Notifications
    GET_NOTIFICATIONS: (orgId, enabled) => `Notification/Organization/${orgId}/Enabled/${enabled}`,
    UPDATE_NOTIFICATIONS: (orgId) =>`Notification/Organization/${orgId}`,



    // New Sign Up Routes
    GET_SET_UP_INFO: 'User/GetSetUpInfo',
    CREATE_VBOUSER: 'User/CreateVboUser',
    CREATE_BACKUP_APPLICATION: 'User/CreateApplication',
    GET_APP_PERMISSION_LINK: 'User/GetAppPermissionLink',
    CREATE_ADMIN_GROUP: 'User/CreateAdminGroup',
    ADD_TO_VEEAM: 'User/AddToVeeam',
    FORGOT_PASSWORD: 'User/ForgotPassword',

    //Settings Page
    SET_MANAGED: 'User/Managed', 
    SET_RESTORE_MAIL_TO: 'User/RestoreMailTo', 
    SET_TAWK: 'User/TawkChat',
    SET_NEW_STYLE_NOTIFICATIONS: 'User/NewStyleNotifications',
    // Task 9 (D3/N6) — the suppression-expiry digest switch. Read and write share one HTTP path,
    // deliberately not the WCF-backed OrgSettings read that carries newStyleNotifications.
    GET_SUPPRESSION_EXPIRY_WARNINGS: (orgId) => `User/SuppressionExpiryWarnings/${orgId}`,
    SET_SUPPRESSION_EXPIRY_WARNINGS: (orgId, enabled) => `User/SuppressionExpiryWarnings/${orgId}/${enabled}`,
    SET_CW_COMPANYID: 'User/CWCompany', 
    SET_CW_AGREEMENTID: 'User/CWAgreement', 
    SET_CW_DISC_ADDNO: 'User/CWDiscAddNo', 
    SET_CW_PACKAGE_ADDNO: 'User/CWPackageAddNo', 
    SET_ADMIN_EMAIL: 'User/AdminEmail', 
    SET_NOTIFICATION_EMAIL: 'User/NotificationEmail', 
    GET_ORG_SETTINGS: 'User/OrgSettings', 
    GET_ALL_SETTINGS: 'User/Settings', 
    GET_ALL_NOTIFICATION_SETTINGS: 'User/TenantNotificationSettings',
    ADD_NOTIFICATION_MAIL: 'User/TenantNotification',
    DELETE_NOTIFICATION_MAIL: 'User/TenantNotification',
    UPDATE_NOTIFICATION_MAIL: 'User/TenantNotification',
    SET_ENCRYPTION: 'User/Encryption', 
    // MasterAdmin

    GET_MASTERADMIN_RESELLER_ORG: 'MasterAdmin/GetResellerOrgs',
    GET_MASTERADMIN_RESELLER_ORG_CACHE: 'MasterAdmin/GetResellerOrgsFromCache',
    GET_MASTERADMIN_RESELLER_ORG_STATUS: 'MasterAdmin/GetResellerOrgsStatus',
    GET_MA_RESELLER_ORG: 'MasterAdmin/GetMasteradminOrgs',
    GET_MA_RESELLER_ORG_CACHE: 'MasterAdmin/GetMasterAdminOrgsFromCache',
    GET_MA_RESELLER_ORG_STATUS: 'MasterAdmin/GetMasterAdminOrgsStatus',
    GET_MASTERADMIN_RESELLERS: 'MasterAdmin/GetResellers',
    UPDATE_ORG: 'MasterAdmin/UpdateOrg',
    DELETE_ORG: 'MasterAdmin/DeleteOrg',
    CHANGE_ORG_STATUS: 'MasterAdmin/ChangeOrgStatus',
    CONVERT_ORG_TO_RESELLER: 'MasterAdmin/ConvertToReseller',
    DELETE_RESELLER: 'MasterAdmin/DeleteReseller',
    UPDATE_RESELLER: 'MasterAdmin/UpdateReseller',
    RUN_INVOICE_PROCESS: 'MasterAdmin/RunInvoiceProcess',
    RUN_INVOICE_BATCH: 'MasterAdmin/RunInvoiceBatch',
    RUN_BATCH: 'MasterAdmin/RunBatch',
    PROXY_TEST: 'MasterAdmin/ProxyTest',
    GET_JOB_LIST: 'MasterAdmin/GetJobList',
    CREATE_CONNECTWISE_INVOICE: 'MasterAdmin/CreateCWInvoices',

    // KnownErrorPattern
    GET_KNOWN_ERROR_PATTERNS:       'KnownErrorPattern/GetAll',
    GET_KNOWN_ERROR_PATTERN:        (id) => `KnownErrorPattern/${id}`,
    CREATE_KNOWN_ERROR_PATTERN:     'KnownErrorPattern/Create',
    UPDATE_KNOWN_ERROR_PATTERN:     (id) => `KnownErrorPattern/${id}`,
    // Task 9 phase 3B (N7) — read the deactivation impact before offering the irreversible action.
    KNOWN_ERROR_SUPPRESSION_IMPACT: (id) => `KnownErrorPattern/${id}/SuppressionImpact`,
    DEACTIVATE_KNOWN_ERROR_PATTERN: (id) => `KnownErrorPattern/${id}/Deactivate`,
    REACTIVATE_KNOWN_ERROR_PATTERN: (id) => `KnownErrorPattern/${id}/Reactivate`,
    TEST_KNOWN_ERROR_REGEX:         'KnownErrorPattern/TestRegex',

    // Error Suppression (Task 9). Proxied by CoreAPIFrontEnd/Controllers/JobErrorSuppressionController
    // to the backend controller of the same name — see Helpers/SuppressionApi.js.
    GET_SUPPRESSIBLE_KNOWN_ERRORS:  'JobErrorSuppression/GetKnownErrors',
    GET_SUPPRESSIBLE_KNOWN_ERROR:   (id) => `JobErrorSuppression/KnownError/${id}`,
    GET_SUPPRESSION_JOBS:           'JobErrorSuppression/Jobs',
    GET_ACTIVE_SUPPRESSIONS:        'JobErrorSuppression/GetActive',
    GET_RECENTLY_ENDED_SUPPRESSIONS:'JobErrorSuppression/GetRecentlyEnded',
    REINSTATE_SUPPRESSION:          (id) => `JobErrorSuppression/${id}/Reinstate`,
    CREATE_SUPPRESSION:             'JobErrorSuppression/Create',
    AMEND_SUPPRESSION:              (id) => `JobErrorSuppression/${id}`,
    REMOVE_SUPPRESSION:             (id) => `JobErrorSuppression/${id}`,
    REMOVE_SUPPRESSIONS_FOR_ERROR:  (knownErrorId) => `JobErrorSuppression/KnownError/${knownErrorId}`,

    // ConnectWise billing sync (Task 37). Proxied by
    // CoreAPIFrontEnd/Controllers/ResellerBillingSyncController to the backend controller of the
    // same name — see Helpers/BillingSyncApi.js. Scoped to the caller's own reseller by a header
    // the proxy resolves from the token, so no route here carries a reseller id.
    BILLING_SYNC_CONFIG:            'ResellerBillingSync/Config',
    BILLING_SYNC_TEST_CONNECTION:   'ResellerBillingSync/TestConnection',
    BILLING_SYNC_COMPANIES:         'ResellerBillingSync/Companies',
    BILLING_SYNC_AGREEMENTS:        (companyId) => `ResellerBillingSync/Agreements?companyId=${companyId}`,
    BILLING_SYNC_CUSTOMERS:         'ResellerBillingSync/Customers',
    BILLING_SYNC_CUSTOMER_MAPPING:  'ResellerBillingSync/CustomerMapping',
    BILLING_SYNC_CW_PRODUCTS:       'ResellerBillingSync/CwProducts',
    BILLING_SYNC_PRODUCT_MAPPINGS:  'ResellerBillingSync/ProductMappings',
    BILLING_SYNC_PREPARE_DRY_RUN:   'ResellerBillingSync/PrepareDryRun',
    BILLING_SYNC_DRY_RUN:           'ResellerBillingSync/DryRun',
    BILLING_SYNC_STATE:             'ResellerBillingSync/SyncState',
    BILLING_SYNC_PENDING_WORK:      'ResellerBillingSync/PendingWork',
    BILLING_SYNC_ENABLE:            'ResellerBillingSync/Enable',
    BILLING_SYNC_DISABLE:           'ResellerBillingSync/Disable',
    BILLING_SYNC_DISCARD:           'ResellerBillingSync/Discard',
    BILLING_SYNC_ACKNOWLEDGE:       'ResellerBillingSync/Acknowledge',
    BILLING_SYNC_SCOPE:             'ResellerBillingSync/Scope',
    BILLING_SYNC_REBUILD:           'ResellerBillingSync/Rebuild',
    BILLING_SYNC_QUEUE_FOR_SYNC:    'ResellerBillingSync/QueueForSync',
    BILLING_SYNC_PRESENCE:          'ResellerBillingSync/Presence',
    BILLING_SYNC_PRESENCE_RELEASE:  'ResellerBillingSync/Presence/Release',
    BILLING_SYNC_STATUS:            'ResellerBillingSync/Status',
    BILLING_SYNC_RETRY_STATE:       'ResellerBillingSync/RetryState',
    BILLING_SYNC_RETRY:             'ResellerBillingSync/Retry',
    BILLING_SYNC_RETRY_LINE:        (itemId) => `ResellerBillingSync/Retry/${itemId}`,

    // Logs
    GET_ADMIN_LOGS: 'Log/GetAdminLogs',
    GET_LOGS: 'Log/GetLogs',
    GET_SELECT_ITEMS: 'Log/GetSelectItems',
    GET_IS_DCS_ADMIN: 'User/GetIsDcsAdmin',

    //Main page calls
    DISABLE_JOB: 'User/Job/{jobId}/disable',
    ENABLE_JOB: 'User/Job/{jobId}/enable',
    STOP_JOB: 'User/Job/{jobId}/stop',
    ADD_JOB: 'User/Job',
    START_JOB: 'User/Job/{jobId}/start',
    EDIT_JOB: 'User/Job',
    DELETE_JOB: 'User/Job',
    DELETE_REPO: 'User/Repository',
    COPY_JOB: 'User/CopyJob',//
    GET_PRODUCT_FEATURE : 'User/ProductFeature',


    // Repositories
    UPDATE_REPOSITORY: 'Repository/UpdateRepository',
    UPDATE_ENCRYPTIONKEY: 'Repository/EncyrptionKey',
    SYNC_ORG_DATA: 'User/SyncOrgData',
    DELETE_REPO_BACKUP: 'Repository/DeleteRepoBackupData',
    
    //Entra 
    ENCRYPT_AND_SAVE: (orgId) => `Entra/Organization/${orgId}/EncryptionKey`,
    GET_ALL_GUARDIAN_JOBS: 'Entra/GetAllGuardianJobs',
    GUARDIAN_JOB: (orgId, tenantId) => `Entra/Organization/${orgId}/GuardianJob/${tenantId}`,
    DELETE_GUARDIAN_JOB: (jobId)=> `Entra/JobId/${jobId}`,
    UPSERT_GUARDIAN_JOB: (orgId) => `Entra/Organization/${orgId}/GuardianJob`,
    ENTRA_BACKUP_LOGS: (orgId, orgName, jobId) => `Entra/Organization/${orgId}/OrgName/${orgName}/Job/${jobId}/Logs`,
    ENTRA_JOB_HISTORY_DOWNLOAD: (orgId, orgName, fileName, userName) => `Entra/BluePrintReportDownload/${orgId}/OrgName/${orgName}/User/${userName}/File/${fileName}`,
    GET_ENTRA_BACKUP_SESSION_LOGS: (orgId, orgName, time) => `Entra/Organization/${orgId}/OrgName/${orgName}/Date/${time}/SessionLogs`,
    GET_ENTRA_BACKUP_DIFF_REPORT: (orgId, orgName, fileName, userName) => `Entra/Organization/${orgId}/OrgName/${orgName}/User/${userName}/File/${fileName}`,
    MANAGE_ENTRA_JOB: (jobId) => `Entra/Jobs/${jobId}`,
    ENTRA_RESTORE_POINTS: (orgId, orgName) => `Entra/Organization/${orgId}/OrgName/${orgName}/RestorePoints`,
    ENTRA_CHANGES: (orgId, date, orgName) => `Entra/Organization/${orgId}/OrgName/${orgName}/Date/${date}/Changes`,
    GET_GUARDIAN_SERVICE_GROUPS: (orgId, tenantId) => `Entra/Organization/${orgId}/Tenant/${tenantId}/ServiceGroups`,
    GET_GUARDIAN_SCHEDULE: 'Entra/GetGuardianSchedule',
    RESTORE_ENTRA_CHANGES: (orgId) =>`Entra/Organization/${orgId}/RestoreConfig`,
    ADD_AZURE_ACCOUNTS: 'Entra/AddAzureBackupAccount',
    CREATE_NEW_AAD_JOB: (orgId, orgName) => `Entra/Organization/${orgId}/${orgName}/Job`,
    GET_AZURE_BUCKET_LIST: 'Entra/AzureBucket',
    GET_GUARDIAN_FILES: (orgId, tenantId, createdDate) => `Entra/Organization/${orgId}/Tenant/${tenantId}/createdDate/${createdDate}/GuardianFile`,
    GUARDIAN_FILE_CONTENT: (orgId, file, tenantId) => `Entra/Organization/${orgId}/Tenant/${tenantId}/File/${file}/Download`,
    CHK_GUARDIAN_CONFIG: (orgId, orgName) => `Entra/Organization/${orgId}/OrgName/${orgName}/BackupConfig`,
    MIGRATE_GUARDIAN_FILE_CONTENT: (orgId, tenantId) => `Entra/Organization/${orgId}/Tenant/${tenantId}/File/Migrate`, 

    // Layout
    GET_TAWKCHAT: (orgId) => `TenantService/TawkChat/${orgId}`,

    //Pricing
    PRICING_MODEL: 'TenantService/TenantServices',
    PRICING_MODEL_ID: 'TenantService/TenantServiceById',
    TENANT_USER_COUNT:'TenantService/VeeamUserCount',
    PRICING_UPDATE: (orgId, plan) => `TenantService/Organization/${orgId}/Plan/${plan}`,
    //Montioring
    GET_365_JOB_STATUS: 'Watch/Get365JobStatusTenantDetailSummary',
    GET_365_JOB_LIVE_STATUS: 'Watch/LiveJobStatus',
    ENTRA_ERROR_COUNT: (orgId) => `Entra/Organization/${orgId}/ErrorCount`,
    //JobManagement
    GET_365_WEEK_JOB_MANAGEMENT_DATE: (orgId, date) => `JobManage/Organization/${orgId}/Date/${date}/WeeklyStatus`,
    GET_365_WEEK_JOB_MANAGEMENT: (orgId) => `JobManage/Organization/${orgId}/WeeklyStatus`,
    GET_365_DAY_JOB_MANAGEMENT: (orgId) => `JobManage/Organization/${orgId}/DayStatus`,
    GET_365_DAY_JOB_MANAGEMENT_DATE: (orgId, date) => `JobManage/Organization/${orgId}/Date/${date}/DayStatus`,

    //Tenant Summary
    GET_TENANT_SUMMARY: 'User/TenantSummary',
    GET_TENANT_MAIL_SUMMARY: 'User/GetTenantMailSummary',
    GET_TENANT_DRIVE_SUMMARY: 'User/GetTenantDriveSummary',
    GET_TENANT_DETAIL_SUMMARY: 'User/TenantDetailSummary',
    GET_USER_COUNT_TOTAL_USAGE: 'User/UserCountTotalUsage',
    GET_ALL_RESTORE_POINTS: (orgId) => `User/Organization/${orgId}/RestorePoints`,
    GET_DISK_USAGE_ASSIGNED_LICENSE: 'User/DiskUsageAndAssignedLicense',

    //Price Management
    GET_ALL_PRICE_MODELS: 'User/GetAllPriceModels',
    GET_ALL_PRICE_FEATURES: 'User/GetAllPriceFeatures',
    GET_ALL_PRICE_BOOKS: 'User/GetAllPriceBooks',
    SAVE_PRICE_MODEL: 'User/SavePriceModel',
    SAVE_PRICE_FEATURE: 'User/SavePriceFeature',
    SAVE_PRICE_BOOK: 'User/SavePriceBook',
    CLONE_PRICE_MODEL: 'User/ClonePriceModel',
    DELETE_PRICE_MODEL: 'User/DeletePriceModel',
    DELETE_PRICE_FEATURE: 'User/DeletePriceFeature',
    DELETE_PRICE_BOOK: 'User/DeletePriceBook',

    ADD_BRANDING:'Branding/AddBranding',
    GET_ALL_BRANDING_SETTINGS:'Branding/GetAllBrandingSettings',
    GET_BRANDING:'Branding/GetBranding',

    //Terms
    GET_ALL_TERMS: 'TenantService/GetAllTerms',
    ADD_TERM: 'User/Term',
    GET_DELETE_TERM: 'User/DeleteTerm',
    GET_UPDATE_TERM: 'User/UpdateTerm'
}



export const Role = {
    User: 'User',
}
export const ApiVersion = {
    number : '/v8',
}

export const Urls = {
    SERVER_PATH: "https://127.0.0.1:4443/",
    HELP: "https://cloudcover365.virtualdcs.co.uk/helpme/",
}